import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from '../../shared/auth/auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit, OnDestroy {
  // @ts-ignore: Property has no initializer and is not definitely assigned
  private authStatusSub: Subscription;
  public isLoading = false;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe((authStatus) => {
        this.isLoading = false;
      });
  }

  onSubmit(form: NgForm): void {
    console.log(form);
    if (!form.invalid) {
      this.isLoading = true;
      this.authService.createUser(
        form.value.firstname,
        form.value.surname,
        form.value.email,
        form.value.password
      );
    }
  }

  ngOnDestroy(): void {
    this.authStatusSub.unsubscribe();
  }
}
